import { notFound } from 'next/navigation'
import { ApiRoutes, BASE_API_URL } from './routes'

interface ApiResponse<T> {
  data: T
  isOk: boolean
}

export const dataFetcher = async (url: string) => {
  const response = await fetch(BASE_API_URL + url, { cache: 'no-cache' })
  const data = await response.json()

  return data
}

export const dataFetcherWithStatus = async <T>(url: string): Promise<ApiResponse<T>> => {
  const response = await fetch(BASE_API_URL + url, { cache: 'no-cache' })
  const data = await response.json()

  if (!response.ok && data.detail) {
    notFound()
  }

  return { data, isOk: response.ok }
}

export const fetcher = (url: string) => fetch(BASE_API_URL + url).then((res) => res.json())

export const postFeedback = async (jsonData: any) => {
  const res = await fetch(BASE_API_URL + ApiRoutes.company.contact, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(jsonData),
  })

  const data = await res.json()

  return data
}
